/**
 * @generated SignedSource<<6950478e97e02c98b00eb97457db19ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type markNotificationAsRead_Mutation$variables = {
  input: string;
};
export type markNotificationAsRead_Mutation$data = {
  readonly markNotificationAsRead: {
    readonly updatedObject: {
      readonly id: string;
      readonly read: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type markNotificationAsRead_Mutation = {
  response: markNotificationAsRead_Mutation$data;
  variables: markNotificationAsRead_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "notificationId",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "read",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "markNotificationAsRead_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NotificationInterfaceUpdatedPayload",
        "kind": "LinkedField",
        "name": "markNotificationAsRead",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "updatedObject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "markNotificationAsRead_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NotificationInterfaceUpdatedPayload",
        "kind": "LinkedField",
        "name": "markNotificationAsRead",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "updatedObject",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e4e82cb3fea401e81b4ef61fe67fb277",
    "id": null,
    "metadata": {},
    "name": "markNotificationAsRead_Mutation",
    "operationKind": "mutation",
    "text": "mutation markNotificationAsRead_Mutation(\n  $input: ID!\n) {\n  markNotificationAsRead(notificationId: $input) {\n    updatedObject {\n      __typename\n      id\n      read\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8edfd329e55c17f864c69835e918af4c";

export default node;
